import Phaser from "phaser";
import { BaseModal } from "@phaser/ui/modals/BaseModal";
import { BlueBtn } from "@phaser/ui/btns/BlueBtn";
import { RedBtn } from "@phaser/ui/btns/RedBtn";
import { getShopItemById } from "@phaser/core/shop/shopCatalog";
import { t } from "@/i18n/i18n";

export class PurchaseModal extends BaseModal {
  private panelW: number;
  private panelH: number;

  private confirmText!: Phaser.GameObjects.Text;
  private priceText!: Phaser.GameObjects.Text;

  private selectedItemId?: string;

  constructor(
    scene: Phaser.Scene,
    width: number,
    height: number,
    onClose?: () => void,
  ) {
    super(scene, { width, height, onClose });

    this.panelW = (width * 681) / 768;
    this.panelH = (height * 486) / 1366;

    this.buildUI(width, height);
    this.setDepth(9999);
  }

  private buildUI(width: number, height: number) {
    // 패널
    const panel = this.scene.add
      .image(width / 2, height / 2, "s-modal-bg")
      .setDisplaySize(this.panelW, this.panelH)
      .setOrigin(0.5);

    // 확인 문구
    this.confirmText = this.scene.add
      .text(width / 2, height / 2 - this.panelH * 0.26, "", {
        fontFamily: "Black Han Sans",
        fontSize: "48px",
        color: "#1C120E",
        align: "center",
        wordWrap: { width: this.panelW * 0.8 },
      })
      .setOrigin(0.5);

    this.priceText = this.scene.add
      .text(width / 2, height / 2, "0 Coins", {
        fontFamily: "Black Han Sans",
        fontSize: "64px",
        color: "#1C120E",
        align: "center",
      })
      .setOrigin(0.5);

    // 예 버튼
    const yesBtn = new BlueBtn(
      this.scene,
      width / 2 - this.panelW * 0.23,
      height / 2 + this.panelH * 0.3,
      t("common.yes"),
      () => {
        if (!this.selectedItemId) return;

        this.scene.events.emit("purchase-execute", {
          itemId: this.selectedItemId,
        });
      },
    );

    // 아니오 버튼
    const noBtn = new RedBtn(
      this.scene,
      width / 2 + this.panelW * 0.23,
      height / 2 + this.panelH * 0.3,
      t("common.no"),
      () => {
        this.scene.events.emit("purchase-confirm-closed");
        this.close();
      },
    );

    this.add([panel, this.confirmText, this.priceText, yesBtn, noBtn]);
  }

  setItem(itemId: string) {
    const item = getShopItemById(itemId);
    if (!item) return;

    this.selectedItemId = itemId;

    const itemName = t(`arrow.${item.id}.name`);

    this.confirmText.setText(
      t("shop.purchase_confirm", {
        name: itemName,
      }),
    );

    this.priceText.setText(
      t("shop.purchase_coin", {
        price: item.price.toLocaleString(),
      }),
    );
  }
}
